<template>
  <div class="header">
    <div class="header-one"
         ref="headerOne">
      <div class="brand"
           style="flex: 1 0 auto;">
        <span v-if="isStatLight"
              style="margin-right:6px">魔镜有数导入</span>
        <!-- <div class="keyWords"
             v-if="postWord">
          <span style="">{{postWord}}</span>
        </div> -->

        <el-tag v-show="defaultSearchForm.custom_rule_id"
                @close="handleCustomRuleNameClose"
                class="selectedType">
          自定义分析: {{custom_rule_name}}
        </el-tag>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.catLabel')+defaultSearchForm.cat_name"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.cat_name"
                  @close="handlecatNameClose"
                  class="selectedType">
            {{$t('baseInfo.catLabel') + sliceText(defaultSearchForm.cat_name)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.postKeyWordLabel')+defaultSearchForm.word"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.word"
                  @close="handleWordClose"
                  class="keyWords">
            {{$t('baseInfo.postKeyWordLabel') + sliceText(defaultSearchForm.word)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.mustKwLabel')+defaultSearchForm.must_kw"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.must_kw"
                  @close="handleMustKwClose"
                  class="keyWords">
            {{$t('baseInfo.mustKwLabel')+sliceText(defaultSearchForm.must_kw)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.shouldKwLabel')+defaultSearchForm.should_kw"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.should_kw"
                  @close="handleShouldKwClose"
                  class="keyWords">
            {{$t('baseInfo.shouldKwLabel')+sliceText(defaultSearchForm.should_kw)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.notKwLabel')+defaultSearchForm.not_kw"
                    placement="bottom">
          <el-tag closable
                  v-if="defaultSearchForm.not_kw"
                  @close="handleNotKwClose"
                  class="keyWords">
            {{$t('baseInfo.notKwLabel')+sliceText(defaultSearchForm.not_kw)}}
          </el-tag>
        </el-tooltip>

        <el-tooltip effect="dark"
                    :content="$t('baseInfo.kolWord')+defaultSearchForm.kol_word"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.kol_word"
                  @close="handleKolWordClose"
                  class="keyWords">
            {{$t('baseInfo.kolWord')+sliceText(defaultSearchForm.kol_word)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.kolMustKwLabel')+defaultSearchForm.kol_must_kw"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.kol_must_kw"
                  @close="handleKolMustKwClose"
                  class="keyWords">
            {{$t('baseInfo.kolMustKwLabel')+sliceText(defaultSearchForm.kol_must_kw)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.kolShouldKwLabel')+defaultSearchForm.kol_should_kw"
                    placement="bottom">
          <el-tag closable
                  v-show="defaultSearchForm.kol_should_kw"
                  @close="handleKolShouldKwClose"
                  class="keyWords">
            {{$t('baseInfo.kolShouldKwLabel')+sliceText(defaultSearchForm.kol_should_kw)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.kolNotKwLabel')+defaultSearchForm.kol_not_kw"
                    placement="bottom">
          <el-tag closable
                  v-if="defaultSearchForm.kol_not_kw"
                  @close="handleKolNotKwClose"
                  class="keyWords">
            {{$t('baseInfo.kolNotKwLabel')+sliceText(defaultSearchForm.kol_not_kw)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.brandLabel')+brand_name"
                    placement="bottom">
          <el-tag closable
                  v-show="brand_name"
                  @close="handleSelectTypeClose"
                  class="selectedType">
            {{$t('baseInfo.brandLabel') + sliceText(brand_name)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.topicLabel')+defaultSearchForm.topic_name"
                    placement="bottom">
          <el-tag closable
                  v-show="topic_name"
                  @close="handleTopicClose"
                  class="keyWords">
            {{$t('baseInfo.topicLabel')+sliceText(defaultSearchForm.topic_name)}}
          </el-tag>
        </el-tooltip>
        <el-tooltip effect="dark"
                    :content="$t('baseInfo.kolLabel')+searchForm.kol_name"
                    placement="bottom">
          <el-tag closable
                  v-show="searchForm.kol_name"
                  @close="handleKolNameClose"
                  class="selectedType selectedKol">
            {{$t('baseInfo.kolLabel')+sliceText(searchForm.kol_name)}}
          </el-tag>
        </el-tooltip>
        <el-tag closable
                v-for="item in custom_filters_list"
                :key="item.id"
                @close="handleCustomFiltersClose(item)"
                class="selectedType">
          {{item.label +'：'}}{{item.name}}{{transformType(item.type)}}
        </el-tag>
        <!-- <el-tag closable
                v-for="item in scenelist"
                :key="item.id"
                @close="handleScenelistClose(item)"
                class="selectedType">
          {{item.label +'：'}}{{item.name}}{{transformType(item.type)}}
        </el-tag> -->
        <el-tag closable
                v-for="item in attrList"
                :key="item.id"
                @close="handleAttrlistClose(item)"
                class="selectedType">
          {{transformNerCol(item.ner_col) +'：'}}{{item.ner_word}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.gender_typ"
                @close="handleGenderTypClose"
                class="selectedType">
          {{$t('baseInfo.gender')+'：'+handelOptionsName(defaultSearchForm.gender_typ,'gender_typ')}}
        </el-tag>
        <el-tag closable
                v-if="age_typ"
                @close="handleAgeTypClose"
                class="selectedType">
          {{$t('baseInfo.age')+'：'+sliceText(age_typ)}}
        </el-tag>
        <el-tag closable
                v-if="city_typ"
                @close="handleCityTypClose"
                class="selectedType">
          {{$t('baseInfo.cityLevel')+'：'+sliceText(city_typ)}}
        </el-tag>
        <el-tag closable
                v-if="g_aspect"
                @close="handleGAspectTypClose"
                class="selectedType">
          {{$t('baseInfo.g_aspect')+'：'+sliceText(g_aspect)}}
        </el-tag>
        <!-- <el-tag closable
                v-if="defaultSearchForm.age_typ"
                @close="handleAgeTypClose"
                class="selectedType">
          {{$t('baseInfo.age')+'：'+handelOptionsName(defaultSearchForm.age_typ,'age_typ')}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.city_typ"
                @close="handleCityTypClose"
                class="selectedType">
          {{$t('baseInfo.cityLevel')+'：'+handelOptionsName(defaultSearchForm.city_typ,'city_typ')}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.g_aspect"
                @close="handleGAspectTypClose"
                class="selectedType">
          {{$t('baseInfo.g_aspect')+'：'+handelOptionsName(defaultSearchForm.g_aspect,'g_aspect')}}
        </el-tag> -->
        <el-tag closable
                v-if="defaultSearchForm.zan_min"
                @close="handleNumClose('zan_min')"
                class="selectedType">
          {{$t('baseInfo.min')+$t('baseInfo.zans')+'：'+defaultSearchForm.zan_min}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.zan_max"
                @close="handleNumClose('zan_max')"
                class="selectedType">
          {{$t('baseInfo.max')+$t('baseInfo.zans')+'：'+defaultSearchForm.zan_max}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.comment_min"
                @close="handleNumClose('comment_min')"
                class="selectedType">
          {{$t('baseInfo.min')+$t('baseInfo.comments')+'：'+defaultSearchForm.comment_min}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.comment_max"
                @close="handleNumClose('comment_max')"
                class="selectedType">
          {{$t('baseInfo.max')+$t('baseInfo.comments')+'：'+defaultSearchForm.comment_max}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.repost_min"
                @close="handleNumClose('repost_min')"
                class="selectedType">
          {{$t('baseInfo.min')+$t('baseInfo.reposts')+'：'+defaultSearchForm.repost_min}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.repost_max"
                @close="handleNumClose('repost_max')"
                class="selectedType">
          {{$t('baseInfo.max')+$t('baseInfo.reposts')+'：'+defaultSearchForm.repost_max}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.follower_min"
                @close="handleNumClose('follower_min')"
                class="selectedType">
          {{$t('baseInfo.min')+$t('baseInfo.fansNum')+'：'+defaultSearchForm.follower_min}}
        </el-tag>
        <el-tag closable
                v-if="defaultSearchForm.follower_max"
                @close="handleNumClose('follower_max')"
                class="selectedType">
          {{$t('baseInfo.max')+$t('baseInfo.fansNum')+'：'+defaultSearchForm.follower_max}}
        </el-tag>
        <div class="edit"
             @click="openDialog">
          <el-tooltip class="item"
                      effect="dark"
                      :content="$t('mainHead.eidtTooltip')"
                      placement="top">
            <i class="el-icon-edit-outline"></i>
          </el-tooltip>
        </div>
        <div class="save"
             @click="saveProj"
             style="margin-left:10px;">
          <i class="iconfont icon-baocun"
             style="color:#3a63f3;font-size:14px;"></i>
          <el-button style="margin-left:4px;cursor:pointer"
                     type="text"
                     :loading="loading_save">{{$t('mainHead.saveProj')}}</el-button>
        </div>
      </div>
      <div class="time-pick"
           style="padding:6px 0;flex:auto;justify-content: space-between;">
        <div style="display:flex;align-items: center;">
          <div class="checkBox"
               style="margin-right:10px;">
            <div class="labelText"
                 style="display:inline-block;margin-right:10px;"> 作者 : </div>
            <el-checkbox-group v-model="searchForm.kol_type"
                               :min="1"
                               @change="handleAuthorChange"
                               style="display:inline-block;">
              <el-checkbox label="consumer">消费者 <el-tooltip class="item"
                            effect="dark"
                            content="粉丝数≤100"
                            placement="top">
                  <i class="iconfont icon-Hint"></i>
                </el-tooltip>
              </el-checkbox>
              <el-checkbox label="koc">KOC
                <el-tooltip class="item"
                            effect="dark"
                            content="100<抖音粉丝数<5w；100<微博粉丝数<10w；100<小红书粉丝数<1w"
                            placement="top">
                  <i class="iconfont icon-Hint"></i>
                </el-tooltip>
              </el-checkbox>
              <el-checkbox label="kol">KOL
                <el-tooltip class="item"
                            effect="dark"
                            content="抖音粉丝数>5w；微博粉丝数>10w；小红书粉丝数>1w"
                            placement="top">
                  <i class="iconfont icon-Hint"></i>
                </el-tooltip>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="checkBox"
               style="margin-right:10px;">
            <div class="labelText"
                 style="display:inline-block;margin-right:10px;"> 平台 : </div>
            <template v-if="!isStatLight">
              <el-checkbox-group v-model="searchForm.plat"
                                 :min="1"
                                 :disabled="isPlatLoading"
                                 @change="handlePlantChange"
                                 style="display:inline-block;">
                <el-checkbox label="weibo">{{$t('mainHead.platList_weibo')}}</el-checkbox>
                <el-checkbox label="douyin">{{$t('mainHead.platList_douyin')}}</el-checkbox>
                <el-checkbox label="xhs"
                             class="hide-label">{{$t('mainHead.platList_xhs')}}</el-checkbox>
                <el-select v-model="xhs_plat_ocr"
                           placeholder="请选择"
                           class="platSelect"
                           size="mini"
                           ref="xhsSelect"
                           :disabled="isPlatLoading"
                           @visible-change="xhsVisible"
                           @change="xhsOcrPlatChange">
                  <el-option label="小红书"
                             value="xhs"></el-option>
                  <el-option label="小红书（含视频转文字）"
                             value="xhs_ocr"></el-option>
                </el-select>
              </el-checkbox-group>
            </template>
            <template v-if="isStatLight">
              <el-checkbox-group v-model="searchForm.plat"
                                 :min="platMin"
                                 :disabled="isPlatLoading"
                                 @change="handlePlantChange"
                                 style="display:inline-block;">
                <span v-for="item,index in platData"
                      :key="item.value"
                      style="margin-right:10px;">
                  <div style="display:inline-block;">
                    <el-checkbox class="hide-label"
                                 :label="item.value"></el-checkbox>
                    <el-select v-model="item.selectedValue"
                               size="mini"
                               placeholder="请选择"
                               class="platSelect"
                               :disabled="isPlatLoading"
                               :ref="'plat_select'+index"
                               @visible-change="platVisible($event,index)"
                               @change="ocrPlatChange">
                      <el-option v-for="option in item.options"
                                 :key="option.value"
                                 :label="option.label"
                                 :value="option.value"></el-option>
                    </el-select>
                  </div>
                </span>
              </el-checkbox-group>
            </template>
          </div>

          <div v-if="!isStatLight"
               style="display:inline-block;">
            <el-popover placement="bottom-start"
                        width="246"
                        popper-class="otherPlatPopover"
                        trigger="hover">
              <div class="otherPlat">
                <span v-for="item,index in fusionPlatData"
                      :key="item.value"
                      :class="{'plat_item':index!=3}"
                      @click="goFusion">{{item.name}}</span>
              </div>
              <div style="color:#3a63f3;display:inline-block;cursor:pointer;margin-right:20px;min-width:58px;"
                   slot="reference"
                   @click="goFusion">更多平台</div>
            </el-popover>
          </div>
          <div style="display:inline-block;">
            <template v-if="isStatLight &&otherPlatArr.length>0">
              <el-popover placement="bottom-start"
                          title="魔镜有数平台"
                          width="270"
                          @hide="platPopoverHide"
                          popper-class="otherPlatPopover"
                          trigger="hover">
                <div>
                  <el-checkbox-group v-model="searchForm.plat"
                                     :min="morePlatMin"
                                     :disabled="isPlatLoading"
                                     @change="handlePlantChange">
                    <span v-for="item in otherPlatArr"
                          :key="item.value"
                          style="margin:0 20px 10px 0;display:inline-block;">
                      <el-checkbox :label="item.value"
                                   :class="{ 'hide-label': item.value=='kuaishou' }">{{item.name}}</el-checkbox>
                      <el-select v-model="ks_plat_ocr"
                                 placeholder="请选择"
                                 class="platSelect"
                                 size="mini"
                                 ref="ksSelect"
                                 :disabled="isPlatLoading"
                                 @visible-change="ksVisible"
                                 v-if="item.value=='kuaishou'"
                                 :popper-append-to-body="false"
                                 @change="ksPlatChange">
                        <el-option label="快手"
                                   value="kuaishou"></el-option>
                        <el-option label="快手（含视频转文字）"
                                   value="kuaishou_ocr"></el-option>
                      </el-select>
                    </span>
                  </el-checkbox-group>
                </div>
                <span slot="reference"
                      style="color:#3a63f3;cursor:pointer;margin-right:20px;min-width:58px;display:inline-block;">更多平台</span>
              </el-popover>
            </template>
          </div>
        </div>
        <div class="timePick"
             style="display:flex;">
          <div class="labelText"
               style="display:inline-block;margin-right:10px;line-height:30px;min-width:36px;"> {{$t('mainHead.dateLabel')}} : </div>
          <!-- <MonthPickers v-model="dateTime"
                        @change="dateChange" /> -->
          <DatePicker @on-changeDateTime="dateChange"
                      @on-changeTsType="changeTsType"
                      :defaultTsType="tsType"
                      :dateTime="dateTime"
                      :pickerOptionsStart="pickerOptions_start"
                      :pickerOptionsEnd="pickerOptions_end"
                      :showTsRange="true" />
        </div>
      </div>
    </div>

    <div class="header-two"
         style="padding:0;"
         :style="{ marginTop: headerMarginTop + 'px' }">
      <!-- <template v-if="editableTabs.length>0"> -->
      <NavTabs :navData="editableTabs"
               :hideTabs="hideTabs"></NavTabs>
      <!-- </template> -->

      <!-- <div style="width:100%"> -->
      <!-- <el-tabs class="tabSign"
               v-model="editableTabsValue"
               type="card"
               @tab-click="handleTabClick"
               :before-leave="beforeLeave">
        <el-tab-pane :key="item.name"
                     :disabled="tabDisabled"
                     v-for="item,index in editableTabs"
                     :name="item.name">
          <div slot="label"
               style="padding: 0 20px;"
               @mouseenter="handleMouseEnter(item,index)"
               @mouseleave="handleMouseLeave()">
            <div class="lb"
                 v-if="isShowEditIndex!=index||tabNameValue!=item.title">{{item.title}}</div>
            <div class="lb"
                 v-if="isShowEditIndex==index&&tabNameValue==item.title">
              <el-input size="mini"
                        style="width:80px"
                        placeholder="请输入内容"
                        @click.stop.native=""
                        v-model="newTabNameValue">
              </el-input>
              <i class="el-icon-check"
                 @click.stop="subEditTabName(item)"></i>
              <i class="el-icon-close"
                 @click.stop="closeEditTabName()"></i>
            </div>
            <i class="el-icon-star-on"
               style="color:#fed141;"
               v-if="item.rule_id&&!item.analyse_typ&&!item.origin_user"></i>
            <i class="el-icon-star-on"
               style="color:red;"
               v-if="item.rule_id&&!item.analyse_typ&&item.origin_user"></i>
            <i class="el-icon-edit"
               v-if="tabActiveIndex==index&&isShowEditIndex!=index&&item.analyse_typ!='CustomList'"
               @click.stop="changeTabName(item,index)"></i>
            <i class="el-icon-remove-outline"
               v-if="tabActiveIndex==index&&isShowEditIndex!=index&&item.analyse_typ!='CustomList'"
               @click.stop="hideTab(item)"></i>
          </div>
        </el-tab-pane>
        <el-tab-pane name="AiInterpret"
                     v-if="!$store.state.user.loginInfo.is_partner">
          <div slot="label"
               style="padding: 0 20px;">
            <div @click.stop="aiInterpretFuc">{{$t('mainHead.tabs_ai')}}</div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="more">
          <div slot="label"
               style="padding: 0 20px;">
            <div @click.stop>
              <el-dropdown trigger="click"
                           placement="bottom"
                           @command="showTab">
                <div class="save">
                  更多
                </div>
                <el-dropdown-menu slot="dropdown">
                  <div style="height:200px">
                    <el-scrollbar style="height:100%">
                      <el-dropdown-item v-for="tag in hideTabs"
                                        :key="tag.name"
                                        :command="tag">{{tag.title}}</el-dropdown-item>
                    </el-scrollbar>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="saveBtn">
          <div slot="label"
               style="padding: 0 20px;">
            <div class="save"
                 @click="saveProj"
                 v-loading="loading_save">
              <i class="iconfont icon-baocun"></i>
              <el-button style="margin-left:4px;cursor:pointer"
                         type="text">{{$t('mainHead.saveProj')}}</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs> -->
      <!-- </div> -->
    </div>

    <el-dialog :title="$t('mainHead.eidtTooltip')"
               :visible.sync="dialogVisible"
               width="80%"
               top="5vh"
               custom-class="searchForm"
               :before-close="handleClose">
      <el-form label-position="left"
               label-width="120px"
               :model="searchForm">
        <el-row :gutter="40">
          <el-col :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="12"
                  :xl="12">
            <div class="filter-module">
              <div class="filter-module-title">内容</div>
              <div style="padding: 0px 20px;">
                <div class="h_b">
                  <el-form-item label="搜索方式">
                    <el-radio-group v-model="searchOptions"
                                    size="mini">
                      <el-radio-button label="word">关键词逻辑组合
                        <!-- <el-tooltip class="item"
                              effect="dark"
                              content="支持and、or、not逻辑，和分词用空格隔开；例如：口红 and (唇釉 or 唇彩) not 哑光"
                              placement="top">
                    <i class="iconfont icon-Hint"></i>
                  </el-tooltip> -->
                      </el-radio-button>
                      <el-radio-button label="must_kw">必选+可选+排除</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('search.form_postWord')"
                                v-if="searchOptions == 'word'">
                    <el-input v-model="searchForm.word"
                              size="mini"
                              @blur="keyWordBlur"
                              @focus="keyWordFocus"
                              style="width:86%;margin-right:10px;"
                              placeholder="支持and、or、not逻辑，和分词用空格隔开；例如：口红 and (唇釉 or 唇彩) not 哑光"></el-input>
                    <!-- <span style="color:#BFBFBF">{{$t('search.form_postWord_tip')}}</span> -->
                    <el-popover placement="top"
                                width="360"
                                v-model="visible"
                                trigger="manual"
                                ref="popover"
                                popper-class="keyWordPopover">
                      <div class="keyWordPopover_content">
                        <i class="el-icon-close"
                           @click.stop="visible = false"></i>
                        <div>
                          <div style="font-size:12px;margin-bottom:4px;">{{parse_word_title}}</div>
                          <div style="font-size:12px"
                               v-if="parse_word_subtitle">{{parse_word_subtitle}}</div>
                          <div style="color:#3a63f3;margin-bottom:4px;"
                               v-html="pyoutParserWord"></div>
                          <div style="font-size:12px;">确认逻辑无误再提交搜索，数据更精准哦</div>
                        </div>
                      </div>
                      <el-button type="text"
                                 slot="reference"
                                 @click="keyWordInspect">检查</el-button>
                    </el-popover>
                  </el-form-item>
                  <div v-if="searchOptions == 'must_kw'">
                    <el-form-item label="必选词">
                      <el-input placeholder="词语间为and关系，用英文逗号隔开;所有词语全部匹配（例如：苹果，电脑）"
                                size="mini"
                                v-model="searchForm.must_kw"></el-input>
                    </el-form-item>
                    <el-form-item label="可选词">
                      <el-input placeholder="词语间为or关系，用英文逗号隔开;至少有一个匹配（例如：苹果电脑，macbook）"
                                size="mini"
                                v-model="searchForm.should_kw"></el-input>
                    </el-form-item>
                    <el-form-item label="排除词">
                      <el-input placeholder="排除相关词语，用英文逗号隔开;（例如：戴尔电脑，惠普电脑）"
                                size="mini"
                                v-model="searchForm.not_kw"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="h_b"
                     style="margin-top:10px">
                  <el-form-item label="搜索方式">
                    <el-radio-group v-model="kol_options"
                                    size="mini">
                      <el-radio-button label="kol_word">关键词逻辑组合
                        <!-- <el-tooltip class="item"
                                effect="dark"
                                content="支持and、or、not逻辑，和分词用空格隔开；例如：超话 and (社区 or 微博) not 生活"
                                placement="top">
                      <i class="iconfont icon-Hint"></i>
                    </el-tooltip> -->
                      </el-radio-button>
                      <el-radio-button label="kol_must_kw">必选+可选+排除</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('search.form_user_name')"
                                v-if="kol_options == 'kol_word'">
                    <el-input size="mini"
                              v-model="searchForm.kol_word"
                              placeholder="支持and、or、not逻辑，和分词用空格隔开；例如：超话 and (社区 or 微博) not 生活"></el-input>
                  </el-form-item>
                  <div v-if="kol_options == 'kol_must_kw'">
                    <el-form-item label="必选词">
                      <el-input size="mini"
                                placeholder="词语间为and关系，用英文逗号隔开;所有词语全部匹配（例如：新闻，健身）"
                                v-model="searchForm.kol_must_kw"></el-input>
                    </el-form-item>
                    <el-form-item size="mini"
                                  label="可选词">
                      <el-input placeholder="词语间为or关系，用英文逗号隔开;至少有一个匹配（例如：新闻，论坛）"
                                v-model="searchForm.kol_should_kw"></el-input>
                    </el-form-item>
                    <el-form-item label="排除词">
                      <el-input size="mini"
                                placeholder="排除相关词语，用英文逗号隔开;（例如：新浪，超话社区）"
                                v-model="searchForm.kol_not_kw"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div style="padding:0 10px 0 30px;margin-top:30px;">
                  <el-form-item :label="$t('search.form_category')">
                    <template v-if="dialogVisible">
                      <zTree v-model="selectIds"
                             class="mainHeaderZtreeBox"
                             :style="{ '--leftValue': leftValue }"
                             treeDomId="selectZtree3"
                             treeDomSearchId="searchTree3"
                             @clear="clearSelect"
                             @cidChange="cidChange"></zTree>
                      <span style="color:#BFBFBF">{{$t('search.form_cat_tip')}}</span>
                    </template>
                  </el-form-item>
                  <el-form-item :label="$t('search.form_brand')">
                    <!-- <el-input v-model="searchForm.brand_name"></el-input> -->
                    <el-select v-model="searchForm.brand_name"
                               filterable
                               clearable
                               remote
                               multiple
                               collapse-tags
                               size="small"
                               :remote-method="remoteMethod"
                               :loading="loading"
                               style="width:100%"
                               :placeholder="$t('search.form_brand_holder')"
                               @remove-tag="handleRemove">
                      <el-option v-for="item in brandOptions"
                                 :key="item.name"
                                 :label="item.name"
                                 :value="item.name">
                      </el-option>
                    </el-select>
                    <span style="color:#BFBFBF">{{$t('search.form_brand_tip')}}</span>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="12"
                  :xl="12"
                  style="padding:0 20px;">
            <div class="filter-module"
                 style="margin-bottom:30px;">
              <div class="filter-module-title">发帖人属性</div>
              <div style="padding: 0px 20px;">
                <el-form-item label="粉丝数">
                  <el-input size="mini"
                            v-model.trim="searchForm.follower_min"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                  <span style="margin: 0 16px 0 6px">~</span>
                  <el-input size="mini"
                            v-model.trim="searchForm.follower_max"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                </el-form-item>
                <el-form-item label="性别">
                  <el-select v-model="searchForm.gender_typ"
                             filterable
                             clearable
                             size="mini"
                             style="width:100%"
                             placeholder="请选择">
                    <el-option v-for="item in genderOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="年龄">
                  <el-select v-model="searchForm.age_typ"
                             filterable
                             clearable
                             multiple
                             size="mini"
                             style="width:100%"
                             placeholder="请选择，可多选">
                    <el-option v-for="item in ageOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="城市级别">
                  <el-select v-model="searchForm.city_typ"
                             filterable
                             clearable
                             multiple
                             size="mini"
                             style="width:100%"
                             placeholder="请选择，可多选">
                    <el-option v-for="item in cityLevelOptions"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="filter-module">
              <div class="filter-module-title">帖子互动指标 & 内容属性</div>
              <div style="padding: 0px 20px;">
                <el-form-item label="情感正负">
                  <!-- <el-select v-model="searchForm.g_aspect"
                               filterable
                               clearable
                               multiple
                               style="width:100%"
                               placeholder="请选择，可多选">
                      <el-option v-for="item in aspectOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select> -->
                  <el-checkbox-group v-model="searchForm.g_aspect"
                                     style="display:inline-block;">
                    <el-checkbox v-for="item in aspectOptions"
                                 :key="item.value"
                                 :label="item.value">{{item.label}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="帖子去水">
                  <el-checkbox-group v-model="searchForm.filter_ad"
                                     style="display:inline-block;">
                    <el-checkbox label="ad">去广告</el-checkbox>
                    <el-checkbox label="repost">去转发</el-checkbox>
                    <el-checkbox label="dedup">去重复</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item :label="$t('search.form_topic')">
                  <el-select v-model="searchForm.topic_name"
                             filterable
                             clearable
                             remote
                             multiple
                             collapse-tags
                             size="mini"
                             :remote-method="remoteMethodTopic"
                             :loading="loadingTopic"
                             style="width:100%"
                             :placeholder="$t('search.form_topic_holder')"
                             @remove-tag="handleRemoveTopic">
                    <el-option v-for="item in topicOptions"
                               :key="item.name"
                               :label="item.name"
                               :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="地域">
                    <el-select v-model="searchForm.location_typ"
                               filterable
                               clearable
                               style="width:100%"
                               placeholder="请选择">
                      <el-option v-for="item in locationOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="兴趣">
                    <el-select v-model="searchForm.interest_typ"
                               filterable
                               clearable
                               style="width:100%"
                               placeholder="请选择">
                      <el-option v-for="item in interestOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item> -->
                <el-form-item label="点赞数">
                  <el-input size="mini"
                            v-model.trim="searchForm.zan_min"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                  <span style="margin: 0 16px 0 6px">~</span>
                  <el-input size="mini"
                            v-model.trim="searchForm.zan_max"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                </el-form-item>
                <el-form-item label="评论数">
                  <el-input size="mini"
                            v-model.trim="searchForm.comment_min"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                  <span style="margin: 0 16px 0 6px">~</span>
                  <el-input size="mini"
                            v-model.trim="searchForm.comment_max"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                </el-form-item>
                <el-form-item label="转发数">
                  <el-input size="mini"
                            v-model.trim="searchForm.repost_min"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                  <span style="margin: 0 16px 0 6px">~</span>
                  <el-input size="mini"
                            v-model.trim="searchForm.repost_max"
                            style="width: 188px; margin-right: 10px">
                  </el-input>
                </el-form-item>
                <el-form-item label="属性">
                  <div v-for="items in searchFormAttrList"
                       :key="items.id"
                       class="mb10">
                    <el-select v-model="items.ner_col"
                               filterable
                               clearable
                               size="mini"
                               style="width:188px;margin-right: 10px"
                               placeholder="请选择">
                      <el-option v-for="item in nerColOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input v-model.trim="items.ner_word"
                              placeholder="请输入"
                              class="mr10"
                              size="mini"
                              style="width: 218px;">
                    </el-input>
                    <div style="width:10%;display:inline-block">
                      <i class="el-icon-circle-plus cp iconBtn mr10"
                         @click="addTableRow()"></i>
                      <i class="el-icon-remove cp iconBtn"
                         @click="deleTableRow(items.id)"></i>

                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary"
                   @click="submitForm">{{$t('search.searchBtnLab')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import {
  getBrands,
  getTopic,
  getGlobalParams,
  getPyoutParser,
} from '@/api/search'
import { getUid, getParams } from '@/api/public'
import { saveProj } from '@/api/baseInfo'
import { handelBrandNameOptions, getObjFromUrl } from '@/utils'
import MonthPickers from '../components/monthPickers/MonthPickers.vue'
import zTree from '@/components/zTree.vue'
import { timeRnage } from '@/mixins/mixins.js'
import { getNav, setNav } from '@/api/custom'
import { DatePicker, pickerUtils, LuxonTime } from 'common'
import NavTabs from '@/components/navTabs/NavTabs.vue'
//import { getLastMonth } from '@/utils'
export default {
  name: 'MainHeader',
  mixins: [timeRnage],
  components: {
    zTree,
    MonthPickers,
    DatePicker,
    NavTabs,
  },
  data() {
    return {
      searchOptions: 'word',
      kol_options: 'kol_word',
      formParams: {},
      selectIds: [],
      dialogVisible: false,
      loading: false,
      loading_save: false,
      loadingTopic: false,
      brandOptions: [],
      topicOptions: [],
      defaultSearchForm: {}, //弹窗条件关闭后打开的重新赋值
      custom_filters_list: [],
      searchForm: {
        plat: [], //平台
        kol_type: [], //kol类型
        brand_name: [], //品牌名称
        topic_name: [], //话题
        filter_ad: [], //帖子去水
        must_kw: '', //必选词
        should_kw: '', //可选词
        not_kw: '', //排除词
        word: '', //帖子关键词
        kol_must_kw: '', //用户名必选词
        kol_should_kw: '', //用户名可选词
        kol_not_kw: '', //用户名排除词
        kol_word: '', //用户名词
        kol_id: '', //达人id
        kol_name: '', //达人名称
        brand_id: '', //品牌id
        cat_id: '', //类目id
        cat_name: '', //类目名称
        custom_filters: '', //将选中声量词页面的参数聚合[{"rule_id":"22df926f-cb8f-45fb-98ae-2aeb8b015e98","analyse_typ":"people_word","label_level":"2","words":"女性","aspect_type":"1"}]
        gender_typ: '',
        age_typ: [],
        location_typ: '',
        city_typ: [],
        g_aspect: [],
        interest_typ: '',
        zan_max: '',
        zan_min: '',
        comment_max: '',
        comment_min: '',
        repost_max: '',
        repost_min: '',
        follower_max: '',
        follower_min: '',
        ner_col: '',
        ner_word: '',
        // fusion_plat:'',//魔镜有数平台
      }, //主要用于弹窗条件的参数绑定
      editableTabs: [],
      hideTabs: [],
      showTabData: [],
      tabs: [
        {
          title: this.$t('mainHead.tabs_baseInfo'),
          name: 'BaseInfo',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_crowdPortrait'),
          name: 'CrowdPortrait',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_talents'),
          name: 'TalentList',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_brand'),
          name: 'BrandList',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_topic'),
          name: 'TopicAnalysis',
          rule_id: '',
          analyse_typ: '',
        },
        {
          title: this.$t('mainHead.tabs_custom'),
          name: 'CustomList',
          rule_id: '',
          analyse_typ: '',
        },
      ],
      brand_name: '',
      topic_name: '',
      age_typ: '',
      city_typ: '',
      g_aspect: '',
      dateTime: [
        this.$store.state.user.startMonth,
        this.$store.state.user.endMonth,
      ],
      startMonth: this.$store.state.user.startMonth,
      endMonth: this.$store.state.user.endMonth,
      KolName: this.$store.state.user.KolName,
      param_val: getObjFromUrl(window.location.href),
      wordsList: this.$store.state.user.words.split(','),
      rulesList: this.$store.state.user.routerRuleId.split(','),
      aspectTypeList: this.$store.state.user.aspectType.split(','),
      authormin: 1,
      catsArr: '',
      tabNameValue: '',
      newTabNameValue: '',
      tabActiveIndex: -1,
      isShowEditIndex: -1,
      leftValue: '100px',
      loadNavDataParam: null,
      genderOptions: [],
      ageOptions: [],
      aspectOptions: [
        {
          value: '1',
          label: '正向',
        },
        {
          value: '0',
          label: '负向',
        },
        {
          value: '2',
          label: '中性',
        },
      ],
      locationOptions: [
        {
          value: '1',
          label: '东北',
        },
        {
          value: '2',
          label: '华北',
        },
      ],
      cityLevelOptions: [],
      interestOptions: [
        {
          value: '1',
          label: '唱歌',
        },
      ],
      nerColOptions: [],
      urlId: this.$store.state.user.urlId,
      globalParamsOption: null,
      attrList: [],
      searchFormAttrList: [],
      tsType: 'month',
      fusionPlatData: [
        {
          value: 'kuaishou',
          name: '快手',
        },
        {
          value: 'bzhan',
          name: 'B 站',
        },
        {
          value: 'jrtt',
          name: '今日头条',
        },
        {
          value: 'weixin',
          name: '微信',
        },
        {
          value: 'zhihu',
          name: '知乎',
        },
        {
          value: 'dewu',
          name: '得物',
        },
        {
          value: 'hupu',
          name: '虎扑',
        },
      ],
      otherPlatArr: [],
      custom_rule_name: '',
      tabDisabled: false,
      visible: false,
      pyoutParserWord: '',
      parse_word_title: '系统会按照以下格式来理解您输入的关键词表达式',
      parse_word_subtitle: null,
      isBlur: '',
      xhs_plat_ocr: 'xhs',
      ks_plat_ocr: 'kuaishou',
      platData: [
        {
          value: 'weibo',
          name: '微博',
          selectedValue: 'weibo',
          options: [
            { value: 'weibo', label: '微博' },
            { value: 'weibo_ocr', label: '微博（含图片转文字）' },
          ],
        },
        {
          value: 'douyin',
          name: '抖音',
          selectedValue: 'douyin',
          options: [
            { value: 'douyin', label: '抖音' },
            { value: 'douyin_ocr', label: '抖音（含视频转文字）' },
          ],
        },
        {
          value: 'xhs',
          name: '小红书',
          selectedValue: 'xhs',
          options: [
            { value: 'xhs', label: '小红书' },
            { value: 'xhs_ocr', label: '小红书（含视频转文字）' },
          ],
        },
      ],
      is_add_ocr: '', //魔镜有数选中的含视频转文字plat
      isPlatLoading: false,
      observer: null,
      headerMarginTop: 58,
    }
  },
  computed: {
    platMin() {
      let min = 1
      let arr = ['xhs', 'douyin', 'weibo']
      let newArr = _.filter(this.searchForm.plat, function (o) {
        return !arr.includes(o)
      })
      if (newArr.length >= 1) {
        min = 0
      }

      return min
    },
    morePlatMin() {
      let min = 1
      let arr = ['xhs', 'douyin', 'weibo']
      let newArr = _.filter(this.searchForm.plat, function (o) {
        return arr.includes(o)
      })
      if (newArr.length >= 1) {
        min = 0
      }
      return min
    },
    isStatLight() {
      return this.searchForm.fusion_plat && this.searchForm.fusion_plat.length
    },
    editableTabsValue: {
      get() {
        if (this.$store.state.user.ActivedTab) {
          return this.$store.state.user.ActivedTab
        } else {
          return 'BaseInfo'
        }
      },
      set(val) {
        this.$store.dispatch('user/changeActivedTab', val)
        // this.$store.state.user.ActivedTab = val
      },
    },
    scenelist() {
      if (this.editableTabs.length > 4 && this.$store.state.user.words != '') {
        let arrs = []
        let arr = []
        for (let i = 0; i < this.rulesList.length; i++) {
          let obj = this.editableTabs.find(
            (item) => item.rule_id == this.rulesList[i]
          )
          arrs.push(obj.title)
        }
        for (let i = 0; i < this.wordsList.length; i++) {
          arr.push({
            name: this.wordsList[i],
            id: this.rulesList[i],
            type: this.aspectTypeList[i],
            label: arrs[i],
          })
        }
        console.log(arr)
        return arr
      } else {
        return []
      }
    },
    custom_filters() {
      if (
        this.$store.state.user.words &&
        this.$store.state.user.words.split(',').length > 0
      ) {
        var customFilters = []
        let aspect_type = ''
        for (
          let i = 0;
          i < this.$store.state.user.words.split(',').length;
          i++
        ) {
          if (this.$store.state.user.aspectType.split(',')[i] == '1') {
            aspect_type = ''
          } else if (this.$store.state.user.aspectType.split(',')[i] == '2') {
            aspect_type = '1'
          } else if (
            this.$store.state.user.aspectType.split(',')[i] == '3' ||
            this.$store.state.user.aspectType.split(',')[i] == '4'
          ) {
            aspect_type = '0'
          } else if (this.$store.state.user.aspectType.split(',')[i] == '5') {
            aspect_type = '2'
          }
          customFilters.push({
            rule_id: this.$store.state.user.routerRuleId.split(',')[i],
            analyse_typ: this.$store.state.user.routerAnalyseTyp.split(',')[i],
            label_level: this.$store.state.user.labelLevel.split(',')[i],
            words: this.$store.state.user.words.split(',')[i],
            aspect_type: aspect_type,
          })
        }
        console.log(JSON.stringify(customFilters))
        return JSON.stringify(customFilters)
      } else {
        return ''
      }
    },
  },
  created() {
    // 时间选择器初始化
    this.initPicker()
    this.getNavData()
    this.getGlobalParamsOption()
    this.getUrlId = _.debounce(this.getUrlIds, 1000)
    this.refreshViewFucDebounce = _.debounce(this.refreshViewFuc, 1000)
    this.getParamsData()
  },
  mounted() {
    this.initResizeObserver()
    this.$eventBus.$on('loadNavData', (val) => {
      if (val.name && val.name != 'load') {
        this.loadNavDataParam = val
        let obj = {
          from: '',
          to: false,
          name: val.name,
        }
        this.setTabNav('hide', obj)
      } else {
        this.editableTabs = []
        this.getNavData()
      }
    })
    // this.tabDrop()
    document.addEventListener('click', this.handleDocumentClick)
  },
  methods: {
    initResizeObserver() {
      this.observer = new ResizeObserver((entries) => {
        _.debounce(() => {
          const entry = entries[0]
          let top = 58
          if (entry.contentRect.height && entry.contentRect.height > 58) {
            top = entry.contentRect.height
          }
          this.headerMarginTop = top + 6
        }, 100)()
      })
      this.observer.observe(this.$refs.headerOne)
    },
    refreshViewFuc() {
      this.$eventBus.$emit('refreshView', true)
    },
    initPicker() {
      const param_val = getObjFromUrl(window.location.href)
      const { start } = param_val
      if (start) {
        const tsType = pickerUtils.getTsType(start)
        if (
          tsType &&
          tsType == 'day' &&
          this.$store.state.user.tsType == 'week'
        ) {
          this.tsType = 'week'
        } else if (tsType) {
          this.tsType = tsType
          this.$store.dispatch('user/changeTsType', tsType)
        }
      } else {
        this.tsType = this.$store.state.user.tsType
      }
    },
    changeTsType(type) {
      // 避免首次加载改变tsType后重复修改
      if (type == this.$store.state.user.tsType) {
        return
      } else {
        //当周度使用向外兼容的方案时需要使用以下屏蔽的代码额外处理
        // let org_start = localStorage.getItem('defaultStartMonth')
        // let org_end = localStorage.getItem('defaultEndMonth')
        // let s = LuxonTime.parseTime(this.dateTime[0], '{y}-{m}')
        // let e = LuxonTime.parseTime(this.dateTime[1], '{y}-{m}')
        // if (
        //   new Date(s) < new Date(org_start) ||
        //   new Date(e) > new Date(org_end)
        // ) {
        //   this.dateTime = [
        //     LuxonTime.parseTime(org_end, '{y}-{m}'),
        //     LuxonTime.parseTime(org_end, '{y}-{m}'),
        //   ]
        // }
        switch (type) {
          case 'month': {
            this.dateTime = [
              LuxonTime.parseTime(this.dateTime[0], '{y}-{m}'),
              LuxonTime.parseTime(this.dateTime[1], '{y}-{m}'),
            ]
            break
          }
          case 'week': {
            const year = this.dateTime[1].split('-')[0]
            const month = this.dateTime[1].split('-')[1]
            const time = pickerUtils.getLastFullWeekStartAndEnd(month, year)
            this.dateTime[0] = time.start
            this.dateTime[1] = time.end
            break
          }
          case 'day': {
            const year = this.dateTime[1].split('-')[0]
            const month = this.dateTime[1].split('-')[1]
            const time = this.getFirstAndLastDayOfMonthFuc(year, month)
            this.dateTime[0] = time.end
            this.dateTime[1] = time.end
            break
          }
        }
        this.$store.dispatch('user/changeTsType', type)
        this.dateChange(this.dateTime)
      }
    },
    getFirstAndLastDayOfMonthFuc(year, month) {
      const firstDay = new Date(year, month - 1, 1)
      const lastDay = new Date(year, month, 0)
      return {
        start: pickerUtils.formatDate(firstDay, '{y}-{m}-{d}'),
        end: pickerUtils.formatDate(lastDay, '{y}-{m}-{d}'),
      }
    },
    sliceText(val) {
      if (val && val.length > 30) {
        return val.slice(0, 30) + '...'
      } else {
        return val
      }
    },
    getGlobalParamsOption() {
      let globalParamsOption = sessionStorage.getItem('globalParamsOption')
        ? JSON.parse(sessionStorage.getItem('globalParamsOption'))
        : null
      if (globalParamsOption) {
        this.genderOptions = globalParamsOption.genders
        this.ageOptions = globalParamsOption.ages
        this.cityLevelOptions = globalParamsOption.city
        this.nerColOptions = globalParamsOption.ner_col
      } else {
        getGlobalParams()
          .then((res) => {
            if (res.status == 'ok') {
              this.genderOptions = res.result.genders
              this.ageOptions = res.result.ages
              this.cityLevelOptions = res.result.city
              this.nerColOptions = res.result.ner_col
              sessionStorage.setItem(
                'globalParamsOption',
                JSON.stringify(res.result)
              )
            }
          })
          .finally(() => {})
      }
    },
    getUrlIds(isSubmit = false) {
      let self = this
      this.tabDisabled = true
      let nerArr = []
      this.attrList.map(function (item) {
        let obj = {}
        if (item.ner_col && item.ner_word) {
          obj['ner_col'] = item.ner_col
          obj['ner_word'] = item.ner_word
          nerArr.push(obj)
        }
      })
      this.searchForm.ner = nerArr
      let formParams = Object.assign({}, this.searchForm)
      formParams.plat = formParams.plat.join(',')
      formParams.brand_name = formParams.brand_name.join(',')
      formParams.topic_name = formParams.topic_name.join(',')
      formParams.kol_type = formParams.kol_type.join(',')
      formParams.filter_ad = formParams.filter_ad.join(',')
      formParams.age_typ = formParams.age_typ.join(',')
      formParams.city_typ = formParams.city_typ.join(',')
      formParams.g_aspect = formParams.g_aspect.join(',')
      if (formParams.fusion_plat) {
        formParams.fusion_plat = formParams.fusion_plat.join(',')
      }
      formParams.custom_filters =
        this.searchForm.custom_filters.length > 0
          ? JSON.stringify(this.searchForm.custom_filters)
          : ''
      this.$eventBus.$emit('showDetail', false)
      if (this.searchOptions == 'word') {
        formParams.must_kw = ''
        formParams.should_kw = ''
        formParams.not_kw = ''
      } else {
        formParams.word = ''
      }
      if (this.kol_options == 'kol_word') {
        formParams.kol_must_kw = ''
        formParams.kol_should_kw = ''
        formParams.kol_not_kw = ''
      } else {
        formParams.kol_word = ''
      }
      let ocr_plats = _.filter(this.platData, function (o) {
        return o.selectedValue && o.selectedValue != o.value
      })
      let ocrArr = []
      if (ocr_plats) {
        ocrArr = _.map(ocr_plats, 'value')
      }
      if (this.ks_plat_ocr == 'kuaishou_ocr') {
        ocrArr.push('kuaishou')
      }
      if (!this.isStatLight) {
        ocrArr = []
        if (this.xhs_plat_ocr == 'xhs_ocr') {
          ocrArr.push('xhs')
        }
      }
      if (_.intersection(this.searchForm.plat, ocrArr).length > 0) {
        formParams.is_add_ocr = _.intersection(
          this.searchForm.plat,
          ocrArr
        ).join(',')
      } else {
        formParams.is_add_ocr = ''
      }
      if (window.mixpanel && isSubmit) {
        window.mixpanel.track('Search Change', formParams)
      }
      return getUid(formParams)
        .then((res) => {
          if (res.status == 'ok') {
            if (res.result.url_id == this.$store.state.user.urlId) {
              this.urlId = res.result.url_id
              this.$eventBus.$emit('showDetail', false)
              this.getParamsData()
            } else {
              self.$store.dispatch('user/changeUrlId', res.result.url_id)
              self.$router.push({
                name: 'detail',
                query: {
                  url_id: res.result.url_id ? res.result.url_id : '',
                  start: LuxonTime.parseTime(
                    this.$store.state.user.startMonth,
                    pickerUtils.tsTypeMap[this.$store.state.user.tsType]
                  ),
                  end: LuxonTime.parseTime(
                    this.$store.state.user.endMonth,
                    pickerUtils.tsTypeMap[this.$store.state.user.tsType]
                  ),
                },
              })
            }
          }
        })
        .catch((e) => {
          this.$message({
            message: e.backMsg,
            type: 'warning',
          })
        })
        .finally(() => {
          this.tabDisabled = false
          this.loading = false
          this.isPlatLoading = false
        })
    },
    getParamsData() {
      let self = this
      if (!this.urlId) {
        return
      }
      getParams({ url_id: this.urlId })
        .then((res) => {
          if (res.status == 'ok') {
            const { cat_id, plat, kol_type, ner, custom_filters } =
              res.result.data
            let brand_name = res.result.data.brand_name
            let topic_name = res.result.data.topic_name
            let age_typ = res.result.data.age_typ
            let city_typ = res.result.data.city_typ
            let g_aspect = res.result.data.g_aspect
            this.selectIds = cat_id.split(',')
            let searchForm = {}
            searchForm = _.cloneDeep(res.result.data)
            searchForm.plat = plat.split(',')
            searchForm.kol_type = kol_type.split(',')
            if (res.result.data.fusion_plat) {
              searchForm.fusion_plat = res.result.data.fusion_plat.split(',')
              this.otherPlatArr = _.filter(self.fusionPlatData, (item) =>
                searchForm.fusion_plat.includes(item.value)
              )
            }
            if (res.result.data.is_add_ocr) {
              let ocr_arr = res.result.data.is_add_ocr.split(',')
              const result = _.map(this.platData, (item) => ({
                ...item,
                selectedValue: _.includes(ocr_arr, item.value)
                  ? item.value + '_ocr'
                  : item.value,
              }))
              if (ocr_arr.includes('kuaishou')) {
                this.ks_plat_ocr = 'kuaishou_ocr'
              }
              if (ocr_arr.includes('xhs')) {
                this.xhs_plat_ocr = 'xhs_ocr'
              }
              this.platData = result
            }
            if (res.result.data.custom_rule_id) {
              searchForm.custom_rule_id = res.result.data.custom_rule_id
              let obj = this.editableTabs.find(
                (item) => item.rule_id == res.result.data.custom_rule_id
              )
              if (obj && obj.title) {
                this.custom_rule_name = obj.title
              }
            }
            if (res.result.data.filter_ad) {
              searchForm.filter_ad = res.result.data.filter_ad.split(',')
            } else {
              searchForm.filter_ad = []
            }
            if (brand_name) {
              brand_name = brand_name.split(',')
            } else {
              brand_name = []
            }
            if (topic_name) {
              topic_name = topic_name.split(',')
            } else {
              topic_name = []
            }
            if (age_typ) {
              age_typ = age_typ.split(',')
            } else {
              age_typ = []
            }
            if (city_typ) {
              city_typ = city_typ.split(',')
            } else {
              city_typ = []
            }
            if (g_aspect) {
              g_aspect = g_aspect.split(',')
            } else {
              g_aspect = []
            }
            if (res.result.data.word) {
              this.searchOptions = 'word'
            }
            if (
              res.result.data.must_kw ||
              res.result.data.should_kw ||
              res.result.data.not_kw
            ) {
              this.searchOptions = 'must_kw'
            }
            if (res.result.data.kol_word) {
              this.kol_options = 'kol_word'
            }
            if (
              res.result.data.kol_must_kw ||
              res.result.data.kol_should_kw ||
              res.result.data.kol_not_kw
            ) {
              this.kol_options = 'kol_must_kw'
            }
            searchForm.brand_name = brand_name
            searchForm.topic_name = topic_name
            searchForm.age_typ = age_typ
            searchForm.city_typ = city_typ
            searchForm.g_aspect = g_aspect
            if (ner.length > 0) {
              let nerArr = []
              ner.map(function (item) {
                let obj = {}
                obj['id'] = _.uniqueId()
                obj['ner_col'] = item.ner_col
                obj['ner_word'] = item.ner_word
                nerArr.push(obj)
              })
              this.attrList = _.cloneDeep(nerArr)
              this.searchFormAttrList = _.cloneDeep(nerArr)
            } else {
              this.searchFormAttrList = [
                {
                  id: _.uniqueId(),
                  ner_col: '',
                  ner_word: '',
                },
              ]
            }
            if (custom_filters) {
              searchForm.custom_filters = JSON.parse(custom_filters)
              let arr = JSON.parse(custom_filters)
              if (self.showTabData.length > 0) {
                let custom_filters_list = _.map(arr, function (item) {
                  let label = ''
                  let labelObj = _.find(self.showTabData, function (o) {
                    return o.rule_id == item.rule_id
                  })
                  if (!labelObj) {
                    labelObj = _.find(self.hideTabs, function (v) {
                      return v.rule_id == item.rule_id
                    })
                  }
                  let obj = null
                  if (labelObj) {
                    label = labelObj.title
                    obj = {
                      name: item.words,
                      id: item.rule_id,
                      label: label,
                      type: item.aspect_type,
                    }
                  }
                  return obj
                })
                this.custom_filters_list = _.compact(custom_filters_list)
              } else {
                this.setCustomFiltersList(arr, 1)
              }
            }
            this.searchForm = _.cloneDeep(searchForm)
            this.defaultSearchForm = _.cloneDeep(searchForm)
            this.brand_name = brand_name.join(' or ')
            this.topic_name = topic_name.join(' or ')
            let _this = this
            this.age_typ = _.map(age_typ, (item) => {
              return _this.handelOptionsName(item, 'age_typ')
            }).join(' or ')
            this.city_typ = _.map(city_typ, (item) => {
              return _this.handelOptionsName(item, 'city_typ')
            }).join(' or ')
            this.g_aspect = _.map(g_aspect, (item) => {
              return _this.handelOptionsName(item, 'g_aspect')
            }).join(' or ')
            this.$store.dispatch('user/changeUrlParams', res.result.data)
            this.$eventBus.$emit('showDetail', true)
          }
        })
        .catch((e) => {
          console.log(e)
          this.$message({
            message: e.backMsg,
            type: 'warning',
          })
        })
        .finally(() => {})
    },
    setCustomFiltersList(arr, num) {
      let self = this
      let numStr = num
      console.log(arr, numStr)
      if (self.showTabData.length > 0) {
        let custom_filters_list = _.map(arr, function (item) {
          let label = ''
          let labelObj = _.find(self.showTabData, function (o) {
            return o.rule_id == item.rule_id
          })
          if (!labelObj) {
            labelObj = _.find(self.hideTabs, function (v) {
              return v.rule_id == item.rule_id
            })
          }
          let obj = null
          if (labelObj) {
            label = labelObj.title
            obj = {
              name: item.words,
              id: item.rule_id,
              label: label,
              type: item.aspect_type,
            }
          }
          return obj
        })
        this.custom_filters_list = _.compact(custom_filters_list)
      } else {
        if (numStr <= 3) {
          console.log(numStr)
          setTimeout(() => {
            self.setCustomFiltersList(arr, numStr + 1)
          }, 100)
        }
      }
    },
    tabDrop() {
      const el = document.querySelector('.tabSign .el-tabs__nav') //找到想要拖拽的那一列
      const _this = this
      Sortable.create(el, {
        onEnd({ newIndex, oldIndex }) {
          //oldIIndex拖放前的位置， newIndex拖放后的位置  //tabOptionList为遍历的tab签
          const currRow = _this.editableTabs.splice(oldIndex, 1)[0] //鼠标拖拽当前的el-tabs-pane
          if (!currRow) {
            return
          }
          _this.editableTabs.splice(newIndex, 0, currRow) //tableData 是存放所以el-tabs-pane的数组
          let obj = {
            from: oldIndex,
            to: newIndex,
            name: currRow.name,
          }
          _this.setTabNav('move', obj)
        },
      })
    },
    setTabNav(type, val) {
      let param = {}
      if (type == 'move') {
        param = {
          order: val,
        }
      } else if (type == 'edit') {
        param = {
          title: val,
        }
      } else if (type == 'hide') {
        param = {
          hide: val,
        }
      }
      setNav(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.closeEditTabName()
            if (type != 'move') {
              this.editableTabs = []
              this.getNavData()
            }
          }
        })
        .catch(() => {})
    },
    subEditTabName(item) {
      let obj = {
        from: item.title,
        to: this.newTabNameValue,
        name: item.name,
      }
      this.setTabNav('edit', obj)
    },
    closeEditTabName() {
      this.tabNameValue = ''
      this.newTabNameValue = ''
      this.isShowEditIndex = -1
    },
    changeTabName(item, index) {
      this.newTabNameValue = item.title
      this.tabNameValue = item.title
      this.isShowEditIndex = index
    },
    hideTab(item) {
      let obj = {
        from: '',
        to: true,
        name: item.name,
      }
      this.setTabNav('hide', obj)
    },
    showTab(item) {
      let obj = {
        from: '',
        to: false,
        name: item.analyse_typ ? item.analyse_typ : item.rule_id,
      }
      this.setTabNav('hide', obj)
    },
    handleMouseEnter(item, index) {
      this.tabActiveIndex = index
    },
    handleMouseLeave() {
      this.tabActiveIndex = -1
    },
    beforeLeave(tabName) {
      if (tabName == 'saveBtn' || tabName == 'more') {
        return false
      }
    },
    transformNerCol(val) {
      let obj = _.find(this.nerColOptions, function (o) {
        return o.value == val
      })
      if (obj && obj.label) {
        return obj.label
      } else {
        return ''
      }
    },
    transformType(val) {
      if (val == '1') {
        return ''
      } else if (val == '2') {
        return '(正向)'
      } else if (val == '3' || val == '4') {
        return '(负向)'
      } else if (val == '5') {
        return '(中性)'
      }
    },
    addTableRow() {
      this.searchFormAttrList.push({
        id: _.uniqueId(),
        ner_col: '',
        ner_word: '',
      })
    },
    deleTableRow(id) {
      if (this.searchFormAttrList.length <= 1) {
        this.searchFormAttrList = [
          {
            id: _.uniqueId(),
            ner_col: '',
            ner_word: '',
          },
        ]
        this.$message({
          message: '至少有一条属性筛选条件！',
          type: 'warning',
        })
        return
      }
      let index = this.searchFormAttrList.findIndex((item) => item.id === id)
      this.searchFormAttrList.splice(index, 1)
      console.log(this.searchFormAttrList, this.attrList)
    },
    dateChange(val) {
      // if (val) {
      //   if (this.startMonth != val[0]) {
      //     this.startMonth = val[0]
      //     this.changeStartMonth(val[0])
      //   }
      //   if (this.endMonth != val[1]) {
      //     this.endMonth = val[1]
      //     this.changeEndMonth(val[1])
      //   }
      // }
      this.$router.push({
        name: 'detail',
        query: {
          url_id: this.urlId,
          start: val[0],
          end: val[1],
        },
      })
    },
    mulltipSelectRemoveTag() {},
    clearSelect() {
      this.selectIds = []
      this.searchForm.cat_id = ''
      this.searchForm.cat_name = ''
    },
    getNavData() {
      getNav()
        .then((res) => {
          if (res.status == 'ok') {
            let data = res.result.content_analyses
            this.showTabData = res.result.content_analyses
            this.hideTabs = res.result.hide_content_analyses
            this.$store.dispatch('user/changeNavContent', data)
            this.$store.dispatch(
              'user/changeNavHideContent',
              res.result.hide_content_analyses
            )
            for (let i = 0; i < data.length; i++) {
              //   if (data[i].analyse_typ == 'ner_type') {
              //     this.editableTabs.splice(1, 0, {
              //       title: data[i].title,
              //       name: data[i].analyse_typ,
              //       rule_id: data[i].rule_id,
              //       analyse_typ: data[i].analyse_typ,
              //     })
              //   } else {
              //   }
              if (data[i].analyse_typ) {
                this.editableTabs.splice(this.editableTabs.length, 0, {
                  title: data[i].title,
                  name: data[i].analyse_typ,
                  rule_id: data[i].rule_id,
                  analyse_typ: data[i].analyse_typ,
                  origin_user: data[i].origin_user,
                  tab_typ: data[i].tab_typ,
                })
              } else {
                //analyse_typ为空的表示是自定义的
                this.editableTabs.splice(this.editableTabs.length, 0, {
                  title: data[i].title,
                  name: data[i].rule_id,
                  rule_id: data[i].rule_id,
                  analyse_typ: '',
                  origin_user: data[i].origin_user,
                  tab_typ: data[i].tab_typ,
                })
              }
            }
            if (this.loadNavDataParam) {
              this.handleTabClick(this.loadNavDataParam)
            }
          }
        })
        .finally(() => {})
    },
    cidChange(cats) {
      if (cats != '' || cats.length != 0) {
        this.selectIds = _.map(cats, 'id')
        this.searchForm.cat_id = _.map(cats, 'id').join(',')
        this.searchForm.cat_name = _.map(cats, (item) =>
          _.join(item.path, '>')
        ).join(',')
      } else {
        this.selectIds = []
        this.searchForm.cat_id = ''
        this.searchForm.cat_name = ''
      }
    },
    handleRemove(key) {},
    openDialog() {
      if (this.defaultSearchForm.cat_id) {
        this.selectIds = this.defaultSearchForm.cat_id.split(',')
      }
      this.searchForm = _.cloneDeep(this.defaultSearchForm)
      if (this.attrList.length > 0) {
        this.searchFormAttrList = _.cloneDeep(this.attrList)
      } else {
        this.searchFormAttrList = [
          {
            id: _.uniqueId(),
            ner_col: '',
            ner_word: '',
          },
        ]
      }
      if (this.defaultSearchForm.word) {
        this.searchOptions = 'word'
      }
      if (
        this.defaultSearchForm.must_kw ||
        this.defaultSearchForm.should_kw ||
        this.defaultSearchForm.not_kw
      ) {
        this.searchOptions = 'must_kw'
      }
      if (this.defaultSearchForm.kol_word) {
        this.kol_options = 'kol_word'
      }
      if (
        this.defaultSearchForm.kol_must_kw ||
        this.defaultSearchForm.kol_should_kw ||
        this.defaultSearchForm.kol_not_kw
      ) {
        this.kol_options = 'kol_must_kw'
      }
      this.dialogVisible = true
      this.getBrands('', 'name')
    },
    handleClose(done) {
      this.selectIds = []
      done()
    },
    isNumber(n) {
      if (!n) {
        return true
      }
      return /^\d+$/.test(n)
    },
    submitForm() {
      let messageText = ''
      if (
        !this.isNumber(this.searchForm.zan_max) ||
        !this.isNumber(this.searchForm.zan_min)
      ) {
        messageText = '点赞数只能为数字'
      } else if (
        !this.isNumber(this.searchForm.comment_max) ||
        !this.isNumber(this.searchForm.comment_min)
      ) {
        messageText = '评论数只能为数字'
      } else if (
        !this.isNumber(this.searchForm.repost_max) ||
        !this.isNumber(this.searchForm.repost_min)
      ) {
        messageText = '转发数只能为数字'
      } else if (
        !this.isNumber(this.searchForm.follower_max) ||
        !this.isNumber(this.searchForm.follower_min)
      ) {
        messageText = '粉丝数只能为数字'
      }
      if (messageText) {
        this.$message({
          message: messageText,
          type: 'warning',
        })
        return false
      }
      if (this.isOnlyOneQueryCondition()) {
        //在编辑弹窗时属性这需要分开判断
        let nerArr = []
        this.searchFormAttrList.map(function (item) {
          let obj = {}
          if (item.ner_col && item.ner_word) {
            obj['ner_col'] = item.ner_col
            obj['ner_word'] = item.ner_word
            nerArr.push(obj)
          }
        })
        if (nerArr.length == 0) {
          this.$message.warning(
            '帖子关键词、用户名、类目、品牌、话题、性别、年龄、城市级别、情感正负、属性不能全部为空'
          )
          return
        }
      }
      if (
        this.searchFormAttrList.length == 1 &&
        (this.searchFormAttrList[0].ner_col == '' ||
          this.searchFormAttrList[0].ner_word == '')
      ) {
        this.attrList = []
      } else {
        this.attrList = _.cloneDeep(this.searchFormAttrList)
      }
      this.dialogVisible = false
      this.getUrlId(true)
    },
    keyWordInspect() {
      if (this.visible || this.isBlur == 'blur') {
        return
      }
      if (this.searchForm.word) {
        this.keyWordBlur()
      } else {
        this.$message({
          message: '请输入帖子关键词！',
          type: 'warning',
        })
      }
    },
    keyWordFocus() {
      this.visible = false
      this.pyoutParserWord = ''
    },
    keyWordBlur() {
      this.isBlur = 'blur'
      let word = _.cloneDeep(this.searchForm.word)
      if (this.searchForm.word) {
        getPyoutParser({ word: this.searchForm.word })
          .then((res) => {
            if (res.status == 'ok') {
              if (res.result.state == 'ok') {
                this.parse_word_title =
                  '系统会按照以下格式来理解您输入的关键词表达式'
                this.pyoutParserWord = res.result.parse_word
              } else if (res.result.state == 'error') {
                if (res.result.error_type == 0) {
                  this.parse_word_title = '您的关键词表达式有误！'
                  this.parse_word_subtitle = null
                  let textArr = word.split('')
                  textArr[
                    [res.result.parse_word[0]]
                  ] = `<span style="color:red">${
                    textArr[res.result.parse_word[0]]
                  }</span>`
                  this.pyoutParserWord = textArr.join('')
                } else if (res.result.error_type == 1) {
                  this.parse_word_title = '关键词检索不支持中文顿号/逗号/引号'
                  this.parse_word_subtitle =
                    '您是否想以and或or的关系筛选多个关键词？'
                  let textArr = word.split('')
                  textArr[
                    [res.result.parse_word[0]]
                  ] = `<span style="color:red">${
                    textArr[res.result.parse_word[0]]
                  }</span>`
                  this.pyoutParserWord = textArr.join('')
                } else if (res.result.error_type == 2) {
                  this.parse_word_title =
                    'and/or/not前后需要加空格，才能生效哦！请修改'
                  this.parse_word_subtitle = null
                  let parseArr = res.result.parse_word
                  let textArr =
                    word.substring(0, parseArr[0]) +
                    `<span style="color:red">${word.substring(
                      parseArr[0],
                      parseArr[1]
                    )}</span>` +
                    word.substring(parseArr[1], word.length)
                  this.pyoutParserWord = textArr
                }
              }
              this.visible = true
            } else {
              this.$message.warning(res.error_msg)
            }
          })
          .catch((e) => {
            this.$message({
              message: e.backMsg,
              type: 'warning',
            })
          })
          .finally(() => {})
      }
    },
    handleDocumentClick(e) {
      if (this.isBlur) {
        this.isBlur = ''
        return
      }
      if (
        this.$refs.popover &&
        !this.$refs.popover.$el.contains(e.target) &&
        this.visible
      ) {
        this.visible = false
      }
    },
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    getBrands(paramVal = [], type = 'id') {
      this.loading = true
      let param = {}
      if (type == 'name') {
        param = { brand_name: paramVal }
      }
      getBrands(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.brandOptions = res.result.data
          }
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.getBrands(query, 'name')
      }
    },
    getTopics(paramVal = [], type = 'id') {
      this.loadingTopic = true
      let param = {}
      if (type == 'name') {
        param = { topic_name: paramVal }
      }
      getTopic(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.topicOptions = res.result.data
          }
          this.loadingTopic = false
        })
        .finally(() => {
          this.loadingTopic = false
        })
    },
    remoteMethodTopic(query) {
      if (query !== '') {
        this.getTopics(query, 'name')
      }
    },
    handleRemoveTopic(key) {},
    handleTabClick(tab, event) {
      this.$eventBus.$emit('TopScroll')
      if (
        tab.name == 'saveBtn' ||
        tab.name == 'CustomList' ||
        tab.name == 'AiInterpret'
      ) {
        return false
      }
      let data = [
        ...this.editableTabs,
        ...this.$store.state.user.navHideContent,
      ]
      let obj = data.find((item) => {
        return item.name == tab.name
      })
      if (obj) {
        this.$store.dispatch('user/changeRuleId', obj.rule_id)
        if (obj.name == 'CrowdPortrait') {
          this.$store.dispatch('user/changeAnalyseTyp', '')
        } else {
          this.$store.dispatch('user/changeAnalyseTyp', obj.analyse_typ)
        }
      }
      //   localStorage.setItem('passActivedTab', '')
      console.log(tab.name)
      //   this.$store.dispatch('user/changeActivedTab', tab.name)
      this.loadNavDataParam = null
    },
    handleWordClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.word = ''
      this.defaultSearchForm.word = ''
      this.changeTab()
      this.getUrlId()
    },
    handleMustKwClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.must_kw = ''
      this.defaultSearchForm.must_kw = ''
      this.changeTab()
      this.getUrlId()
    },
    handleShouldKwClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.should_kw = ''
      this.defaultSearchForm.should_kw = ''
      this.changeTab()
      this.getUrlId()
    },
    handleNotKwClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.not_kw = ''
      this.defaultSearchForm.not_kw = ''
      this.changeTab()
      this.getUrlId()
    },
    handleKolWordClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.kol_word = ''
      this.defaultSearchForm.kol_word = ''
      this.changeTab()
      this.getUrlId()
    },
    handleKolMustKwClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.kol_must_kw = ''
      this.defaultSearchForm.kol_must_kw = ''
      this.changeTab()
      this.getUrlId()
    },
    handleKolShouldKwClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.kol_should_kw = ''
      this.defaultSearchForm.kol_should_kw = ''
      this.changeTab()
      this.getUrlId()
    },
    handleKolNotKwClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.kol_not_kw = ''
      this.defaultSearchForm.kol_not_kw = ''
      this.changeTab()
      this.getUrlId()
    },
    isOnlyOneQueryCondition() {
      //当帖子关键词、用户名、类目、品牌、话题、性别、年龄、城市级别、情感正负、属性只有一个条件时不允许删除
      let arr = []
      if (this.searchForm.word) {
        arr.push(true)
      }
      if (this.searchForm.kol_word) {
        arr.push(true)
      }
      if (this.searchForm.must_kw) {
        arr.push(true)
      }
      if (this.searchForm.should_kw) {
        arr.push(true)
      }
      if (this.searchForm.not_kw) {
        arr.push(true)
      }
      if (this.searchForm.kol_must_kw) {
        arr.push(true)
      }
      if (this.searchForm.kol_should_kw) {
        arr.push(true)
      }
      if (this.searchForm.kol_not_kw) {
        arr.push(true)
      }
      if (this.searchForm.cat_id) {
        arr.push(true)
      }
      if (this.searchForm.brand_name.length > 0) {
        arr.push(true)
      }
      if (this.searchForm.topic_name.length > 0) {
        arr.push(true)
      }
      if (this.searchForm.gender_typ) {
        arr.push(true)
      }
      if (this.searchForm.age_typ.length > 0) {
        arr.push(true)
      }
      if (this.searchForm.city_typ.length > 0) {
        arr.push(true)
      }
      if (this.searchForm.g_aspect.length > 0) {
        arr.push(true)
      }
      if (!this.dialogVisible) {
        if (this.attrList.length > 0) {
          for (let i = 0; i < this.attrList.length; i++) {
            arr.push(true)
          }
        }
      }
      let length = arr.filter((value) => value === true).length
      if (length == 1 && !this.dialogVisible) {
        this.$message.warning(
          '帖子关键词、用户名、类目、品牌、话题、性别、年龄、城市级别、情感正负、属性不能全部为空'
        )
        return true
      } else if (length == 0 && this.dialogVisible) {
        return true
      } else {
        return false
      }
    },
    changeTab() {
      if (this.$store.state.user.ruleId) {
        let ruleId = this.$store.state.user.ruleId
        let obj = _.find(this.editableTabs, function (o) {
          return o.rule_id == ruleId
        })
        if (obj && obj.analyse_typ == '') {
          this.$store.dispatch('user/changeActivedTab', obj.rule_id)
        } else {
          this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
        }
      } else {
        this.$store.dispatch('user/changeActivedTab', 'BaseInfo')
      }
    },
    handleCustomRuleNameClose() {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.custom_rule_id = ''
      this.defaultSearchForm.custom_rule_id = ''
      this.getUrlId()
    },
    handlecatNameClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.cat_id = ''
      this.searchForm.cat_name = ''
      this.defaultSearchForm.cat_id = ''
      this.defaultSearchForm.cat_name = ''
      this.changeTab()
      this.getUrlId()
    },
    handleGenderTypClose() {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.gender_typ = ''
      this.defaultSearchForm.gender_typ = ''
      this.getUrlId()
    },
    handleAgeTypClose() {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.age_typ = []
      this.defaultSearchForm.age_typ = []
      this.age_typ = ''
      this.getUrlId()
    },
    handleCityTypClose() {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.city_typ = []
      this.defaultSearchForm.city_typ = []
      this.city_typ = ''
      this.getUrlId()
    },
    handleGAspectTypClose() {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.g_aspect = []
      this.defaultSearchForm.g_aspect = []
      this.g_aspect = ''
      this.getUrlId()
    },
    handleNumClose(type) {
      if (type == 'zan_max') {
        this.searchForm.zan_max = ''
        this.defaultSearchForm.zan_max = ''
      } else if (type == 'zan_min') {
        this.searchForm.zan_min = ''
        this.defaultSearchForm.zan_min = ''
      } else if (type == 'comment_max') {
        this.searchForm.comment_max = ''
        this.defaultSearchForm.comment_max = ''
      } else if (type == 'comment_min') {
        this.searchForm.comment_min = ''
        this.defaultSearchForm.comment_min = ''
      } else if (type == 'repost_max') {
        this.searchForm.repost_max = ''
        this.defaultSearchForm.repost_max = ''
      } else if (type == 'repost_min') {
        this.searchForm.repost_min = ''
        this.defaultSearchForm.repost_min = ''
      } else if (type == 'follower_max') {
        this.searchForm.follower_max = ''
        this.defaultSearchForm.follower_max = ''
      } else if (type == 'follower_min') {
        this.searchForm.follower_min = ''
        this.defaultSearchForm.follower_min = ''
      }
      this.getUrlId()
    },
    handelOptionsName(val, type) {
      let options = []
      if (type == 'gender_typ') {
        options = this.genderOptions
      } else if (type == 'age_typ') {
        options = this.ageOptions
      } else if (type == 'city_typ') {
        options = this.cityLevelOptions
      } else if (type == 'g_aspect') {
        options = this.aspectOptions
      }
      let obj = options.find((item) => {
        if (item.value == val) {
          return item
        }
      })
      if (obj.label) {
        return obj.label
      } else {
        return ''
      }
    },
    handleAttrlistClose(item) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      let index = this.attrList.findIndex((o) => o.id === item.id)
      this.attrList.splice(index, 1)
      this.getUrlId()
    },
    handleCustomFiltersClose(item) {
      let self = this
      this.custom_filters_list = _.filter(
        self.custom_filters_list,
        function (o) {
          return o.id != item.id
        }
      )
      this.searchForm.custom_filters = _.filter(
        self.searchForm.custom_filters,
        function (o) {
          return o.rule_id != item.id
        }
      )
      this.getUrlId()
    },
    handleScenelistClose(item) {
      let arr = this.$store.state.user.routerRuleId.split(',')
      let arr2 = this.$store.state.user.words.split(',')
      let arr3 = this.$store.state.user.routerAnalyseTyp.split(',')
      let arr4 = this.$store.state.user.aspectType.split(',')
      let arr5 = this.$store.state.user.labelLevel.split(',')
      let index = _.findIndex(arr, function (o) {
        return o == item.id
      })
      if (index != -1) {
        arr.splice(index, 1)
        arr2.splice(index, 1)
        arr3.splice(index, 1)
        arr4.splice(index, 1)
        arr5.splice(index, 1)
        this.$store.dispatch('user/changeRouterRuleId', arr.join(','))
        this.$store.dispatch('user/changeWords', arr2.join(','))
        this.$store.dispatch('user/changeRouterAnalyseTyp', arr3.join(','))
        this.$store.dispatch('user/changeAspectType', arr4.join(','))
        this.$store.dispatch('user/changeLabelLevel', arr5.join(','))
        this.changeTab()
      }
    },
    handleSelectTypeClose(e) {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.brand_name = []
      this.defaultSearchForm.brand_name = []
      this.brand_name = ''
      this.changeTab()
      this.getUrlId()
    },
    handleTopicClose() {
      if (this.isOnlyOneQueryCondition()) {
        return
      }
      this.searchForm.topic_name = []
      this.defaultSearchForm.topic_name = []
      this.topic_name = ''
      this.changeTab()
      this.getUrlId()
    },
    handleKolNameClose(e) {
      this.searchForm.kol_id = ''
      this.searchForm.kol_name = ''
      localStorage.setItem('kol_name', '')
      this.changeTab()
      this.getUrlId()
    },
    changeStartMonth(val) {
      if (!val) {
        this.$message.warning(this.$t('mainHead.rules_message_range'))
        this.startMonth = this.$store.state.user.startMonth
        return
      }
      //   this.$store.dispatch('user/changeStartMonth', this.startMonth)
      this.$router.push({
        name: 'detail',
        query: {
          url_id: this.urlId,
          start: LuxonTime.parseTime(this.startMonth, '{y}-{m}'),
          end: LuxonTime.parseTime(this.endMonth, '{y}-{m}'),
        },
      })
    },
    changeEndMonth(val) {
      if (!val) {
        this.$message.warning(this.$t('mainHead.rules_message_range'))
        this.endMonth = this.$store.state.user.endMonth
        return
      }
      //   this.$store.dispatch('user/changeEndMonth', this.endMonth)
      this.$router.push({
        name: 'detail',
        query: {
          url_id: this.urlId,
          start: LuxonTime.parseTime(this.startMonth, '{y}-{m}'),
          end: LuxonTime.parseTime(this.endMonth, '{y}-{m}'),
        },
      })
    },
    handleAuthorChange() {
      this.$store.dispatch('user/changeKolType', this.searchForm.kol_type)
    },
    handlePlantChange() {
      this.isPlatLoading = true
      this.$store.dispatch('user/changeplants', this.searchForm.plat)
    },
    platPopoverHide() {
      this.$refs.ksSelect[0].blur()
    },
    xhsVisible(e) {
      e == false ? this.$refs.xhsSelect.blur() : ''
    },
    ksVisible(e) {
      e == false ? this.$refs.ksSelect[0].blur() : ''
    },
    platVisible(e, index) {
      let name = 'plat_select' + index
      e == false ? this.$refs[name][0].blur() : ''
    },
    xhsOcrPlatChange() {
      if (this.searchForm.plat.includes('xhs')) {
        this.isPlatLoading = true
        this.getUrlId()
      }
    },
    ocrPlatChange(val) {
      let vals = _.cloneDeep(val)
      if (val.includes('_')) {
        vals = val.split('_')[0]
      }
      if (this.searchForm.plat.includes(vals)) {
        this.isPlatLoading = true
        this.getUrlId()
      }
    },
    ksPlatChange() {
      if (this.searchForm.plat.includes('kuaishou')) {
        this.isPlatLoading = true
        this.getUrlId()
      }
    },
    goFusion() {
      if (window.location.href.indexOf('social.mktindex.com') != -1) {
        window.open('https://fusion.mktindex.com/#/search')
      } else {
        window.open('https://fusiontest.mktindex.com/#/search')
      }
    },
    aiInterpretFuc() {
      this.$store.dispatch('user/changeActivedTab', 'AiInterpret')
    },
    saveProj() {
      this.loading_save = true
      let param = {}
      //   param.plat = this.$store.state.user.plants
      //     ? this.$store.state.user.plants.join(',')
      //     : ''
      //   param.brand_name =
      //     this.$store.state.user.brandName &&
      //     this.$store.state.user.brandName.length
      //       ? this.$store.state.user.brandName.join(',')
      //       : ''
      //   param.cat_id = this.$store.state.user.catId
      //   param.cat_name = this.$store.state.user.catName
      //   param.kol_id = this.$store.state.user.KolId
      //   param.kol_name = this.$store.state.user.KolName
      //   param.word = this.$store.state.user.selectedKeyWards
      param.url_id = this.urlId
      param.start = LuxonTime.parseTime(
        this.$store.state.user.startMonth,
        pickerUtils.tsTypeMap[this.$store.state.user.tsType]
      )
      param.end = LuxonTime.parseTime(
        this.$store.state.user.endMonth,
        pickerUtils.tsTypeMap[this.$store.state.user.tsType]
      )
      param.ts_type = this.$store.state.user.tsType
      param.func = 'ADD'
      saveProj(param)
        .then((res) => {
          if (res.status == 'ok') {
            this.$message.success(this.$t('mainHead.message_saveProj_success'))
          } else {
            this.$message.error(this.$t('mainHead.message_saveProj_failed'))
          }
          this.loading_save = false
        })
        .catch((e) => {
          this.loading_save = false
        })
        .finally(() => {
          this.loading_save = false
        })
    },
  },
  watch: {
    custom_filters: {
      handler(newVal, oldVal) {
        this.getUrlId()
      },
    },
    'searchForm.cat_name': {
      handler(newVal, oldVal) {
        this.leftValue = (newVal ? newVal.length : 0) * 14 + 20 + 'px'
      },
      immediate: true,
    },
    '$store.state.user.plants': {
      handler(newVal, oldVal) {
        this.checkList = newVal
        this.getUrlId()
      },
    },
    '$store.state.user.kolType': {
      handler(newVal, oldVal) {
        this.authorList = newVal
        this.getUrlId()
      },
    },

    '$store.state.user.startMonth': {
      handler(newVal, oldVal) {
        this.startMonth = newVal
        this.dateTime = [newVal, this.dateTime[1]]
        this.initPicker()
        // this.getUrlId()
      },
    },
    '$store.state.user.endMonth': {
      handler(newVal, oldVal) {
        this.endMonth = newVal
        this.dateTime = [this.dateTime[0], newVal]
        this.initPicker()
        // this.getUrlId()
      },
    },
    '$route.query.start': {
      handler(newVal, oldVal) {
        this.startMonth = newVal
        this.dateTime = [newVal, this.dateTime[1]]
        this.initPicker()
        // this.getUrlId()
        if (newVal && oldVal) {
          this.refreshViewFucDebounce()
        }
      },
    },
    '$route.query.end': {
      handler(newVal, oldVal) {
        this.endMonth = newVal
        this.dateTime = [this.dateTime[0], newVal]
        this.initPicker()
        // this.getUrlId()
        if (newVal && oldVal) {
          this.refreshViewFucDebounce()
        }
      },
    },
    '$store.state.user.selectedKeyWards': {
      handler(newVal, oldVal) {
        this.searchForm.word = newVal
        this.getUrlId()
      },
    },
    '$store.state.user.catId': {
      handler(newVal, oldVal) {
        this.searchForm.cat_id = newVal
        this.getUrlId()
      },
    },
    '$store.state.user.catName': {
      handler(newVal, oldVal) {
        this.searchForm.cat_name = newVal
      },
    },
    '$store.state.user.brandName': {
      handler(newVal, oldVal) {
        let name = newVal.length
          ? newVal.map((item) => {
              return item
            })
          : []
        console.log(name)
        this.searchForm.brand_name = name
        this.getUrlId()
      },
    },
    '$store.state.user.topicName': {
      handler(newVal, oldVal) {
        let name = newVal.length
          ? newVal.map((item) => {
              return item
            })
          : []
        this.searchForm.topic_name = name
        this.getUrlId()
      },
    },
    '$store.state.user.KolId': {
      handler(newVal, oldVal) {
        this.searchForm.kol_id = newVal
        this.getUrlId()
      },
    },
    '$store.state.user.KolName': {
      handler(newVal, oldVal) {
        this.searchForm.kol_name = newVal
      },
    },
    '$store.state.user.words': {
      handler(newVal, oldVal) {
        let arr = newVal.split(',')
        this.$set(this, 'wordsList', arr)
        let arrs = this.$store.state.user.routerRuleId.split(',')
        this.$set(this, 'rulesList', arrs)
      },
    },
    '$store.state.user.routerRuleId': {
      handler(newVal, oldVal) {
        let arr = newVal.split(',')
        this.$set(this, 'rulesList', arr)
      },
    },
    '$store.state.user.aspectType': {
      handler(newVal, oldVal) {
        let arr = newVal.split(',')
        this.$set(this, 'aspectTypeList', arr)
      },
    },
    '$store.state.user.urlId': {
      handler(newVal, oldVal) {
        this.urlId = newVal
        console.log(newVal)
        this.getParamsData()
        this.$eventBus.$emit('showDetail', false)
      },
    },
  },
  beforeDestroy() {
    this.$eventBus.$off('loadNavData')
    document.removeEventListener('click', this.handleDocumentClick)
    if (this.observer) {
      this.observer.disconnect()
    }
  },
}
</script>
<style lang="less" scoped>
.otherPlatPopover {
  .otherPlat {
    padding: 10px 10px 0;
    display: inline-block;
    span {
      display: inline-block;
      cursor: pointer;
      color: #3a63f3;
      margin-bottom: 10px;
    }
    .plat_item {
      margin-right: 20px;
    }
  }
  .platSelect {
    width: 120px;
    margin: 0 10px 0 10px;
  }
}
.keyWordPopover {
  .keyWordPopover_content {
    padding: 10px;
    position: relative;
    .el-switch {
      vertical-align: bottom;
    }
    .el-icon-close {
      position: absolute;
      right: -4px;
      top: -4px;
      cursor: pointer;
    }
  }
}
.mainHeaderZtreeBox {
  /deep/ .el-icon-arrow-up {
    display: none;
  }
  /deep/ .el-input__suffix {
    left: var(--leftValue);
    right: auto;
    top: -2px;
  }
}

.tooltipBox {
  width: 400px;
}
.h_b {
  border: 1px solid #ccc;
  padding: 20px 10px 10px 30px;
  border-radius: 4px;
  margin-bottom: 20px;
}
/deep/ .el-tabs__nav {
  white-space: normal;
}
.iconBtn {
  font-size: 20px;
}
.mr10 {
  margin-right: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.tabSign {
  .el-icon-check {
    margin: 0 0 0 4px;
  }
  .el-icon-close {
    width: 14px !important;
  }
  .el-icon-edit {
    color: #000;
    margin-left: 4px;
    margin: 0 0 0 6px;
  }
  .el-icon-remove-outline {
    margin: 0 0 0 4px;
    color: #000;
  }
  .lb {
    display: inline-block;
  }
}
.timePick {
  /deep/ .el-date-editor .el-range-separator {
    width: 7%;
  }
  /deep/ .range-input {
    max-width: 120px;
  }
}
.hide-label ::v-deep .el-checkbox__label {
  display: none;
}
.platSelect {
  width: 120px;
  margin: 0 10px 0 -6px;
  /deep/ .el-input__inner {
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden !important; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
    padding: 0 20px 0 10px;
  }
}
.filter-module {
  border-top: 2px solid #7f828a;
  padding: 30px 0px 10px;
  position: relative;
  // max-width: 700px;
  .filter-module-title {
    position: absolute;
    top: -15px;
    line-height: 30px;
    background-color: #fff;
    color: #18191b;
    font-size: 18px;
    font-weight: 500;
    padding: 0 10px 0 0;
  }
}
.searchForm {
  .el-form-item {
    margin-bottom: 10px !important;
  }
}
.header-one {
  position: fixed;
  width: calc(100% - 190px) !important;
  border-bottom: 1px solid #e6e6e6;
}
.header {
  display: flow-root;
}
</style>
